import React, { useState, useEffect } from 'react';
import { Layout, Dropdown, Menu, Avatar, Modal, Form, Input, message } from 'antd';
import { UserOutlined, LogoutOutlined } from '@ant-design/icons';
import api from '../../services/api';
import { useAuth } from '../../context/AuthContext';


const { Header } = Layout;

const Topbar = () => {
 //  const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')) || {});
   const { auth, logout } = useAuth();
  const user = auth.user;
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();

useEffect(() => {
  if (user) {
    form.setFieldsValue({
      name: user.name,
      email: user.email,
      contactNo: user.contact_no
    });
  }
}, [user, form]);



  const handleUpdateProfile = async (values) => {
    try {
      const response = await api.put('/users/profile', values);
 localStorage.setItem('user', JSON.stringify(response.data.user));
// update context manually
window.location.reload(); // quick fix
      message.success('Profile updated successfully');
      setVisible(false);
    } catch (error) {
      message.error(error.response?.data?.message || 'Failed to update profile');
    }
  };
  

const handleLogout = () => {
  logout(); // from context
  window.location.href = '/login';
};

  const profileMenu = (
    <Menu>
    
      <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={handleLogout}>
        Logout
      </Menu.Item>
    </Menu>
  );

  return (
    <Header style={{ padding: '0 20px', background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      {/* <Button
        type="text"
        icon={<MenuOutlined />}
      /> */}
      <div>&nbsp;</div>
  <Dropdown overlay={profileMenu} trigger={['click']}>
    <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
      <Avatar icon={<UserOutlined />} />
    <span style={{ marginLeft: 8 }}>
  {user?.name || user?.email || "User"}
</span>
    </div>
  </Dropdown>

      <Modal
        title="Profile Settings"
        visible={visible}
        onCancel={() => setVisible(false)}
        onOk={() => form.submit()}
      >
        <Form form={form} layout="vertical" onFinish={handleUpdateProfile}>
          <Form.Item name="name" label="Full Name" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="email" label="Email" rules={[{ required: true, type: 'email' }]}>
            <Input disabled />
          </Form.Item>
          <Form.Item name="contactNo" label="Contact Number">
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </Header>
  );
};

export default Topbar;